import axios from "axios";
import { formatarMesReferenciaPorChave, formatarMesReferencia } from "../util/datas";
import { formatarDadosParaHeatMap } from "../util/utilitarios";

const indicadorApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND}/indicador/graficos/`
})

// Grafico Pie
async function servGetGraficoAlcancePeriodo(dataInicio, dataFim) {
    const { data } = await indicadorApi.get('mv/alcance-periodo', {
        params: { dataInicio, dataFim }
    })
    return data
}

// Grafico Barras
async function servGetGraficoAlcanceMensal(dataInicio, dataFim) {
    const { data } = await indicadorApi.get('mv/alcance-mensal', {
        params: { dataInicio, dataFim }
    })
    return formatarMesReferencia(data);
}

// Graficos detalhamento
async function servGetGraficoDetalhamentoMetrica(dataInicio, dataFim, estabelecimento) {

    let retornoDataTransformada = null

    if (estabelecimento) {
        const estabelecimentoId = estabelecimento.id
        const { data } = await indicadorApi.get('detalhamento-estabelecimento', {
            params: { dataInicio, dataFim, estabelecimentoId }
        })
        retornoDataTransformada = data
    } else {
        const { data } = await indicadorApi.get('mv/detalhamento-metrica', {
            params: { dataInicio, dataFim }
        })
        retornoDataTransformada = data
    }

    return formatarMesReferenciaPorChave(
        retornoDataTransformada,
        'indicadores'
    );

}

// Grafico HeatMap
async function servGetGraficoPercentualAlcanceEstabelecimentosHeatMap(dataInicio, dataFim) {
    const { data } = await indicadorApi.get('mv/percentual-alcance-unidades-heatmap', {
        params: { dataInicio, dataFim }
    })
    console.log(data);

    // return data
    return formatarMesReferenciaPorChave(
        data,
        'indicadores'
    );
}

// Tabela Detalhamento Indicador
async function servGetIndicadoresPorEstabelecimentoAndPeriodo(dataInicio, dataFim, estabelecimentoId) {
    const response = await indicadorApi.get('por-estabelecimento-e-mes', {
        params: { dataInicio, dataFim, estabelecimentoId }
    })
    return response
}

export {
    servGetGraficoAlcancePeriodo,
    servGetGraficoAlcanceMensal,
    // servGetGraficoDetalhamentoEstabelecimento,
    servGetGraficoDetalhamentoMetrica,
    servGetGraficoPercentualAlcanceEstabelecimentosHeatMap,
    servGetIndicadoresPorEstabelecimentoAndPeriodo
}